export default __webpack_public_path__ + "static/media/03203_min.d50503f8.mp3";